import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    mosaic: {
        height: "100%",
        backgroundColor: theme.palette.grey[900],
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
    },
}));
